export default __webpack_public_path__ + "static/media/FBIcon.9b12f71d.svg";